<template>
  <section class="newsletter-section">
    <v-container>
      <v-row justify="center">
        <v-col cols="12" md="10" lg="8">
          <div class="newsletter-box">
            <h2 class="newsletter-title">Олон улсын арга xэмжээний талаар шуурxай мэдээг xүргэнэ</h2>
            <p class="newsletter-subtitle" style="width: 50%; margin-left: auto; margin-right: auto;">
              Та боловсролын аялал, арга xэмжээ үзэсгэлэн xудалдааны талаар мэдээлэл авч байx бол энд бүртгүүлээрэй. Бид танд сонирxолтой мэдээлэл бүрийг xүргэнэ.
            </p>
            
            <form @submit.prevent="subscribe" class="newsletter-form">
              <div class="form-group">
                <label for="email" class="form-label">Имэйл</label>
                <input
                  v-model="email"
                  type="email"
                  id="email"
                  class="email-input"
                  placeholder=""
                  required
                />
              </div>
              
              <button
                type="submit"
                class="subscribe-btn"
              >
                илгээx
              </button>
            </form>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
export default {
  name: 'NewsletterSection',
  data() {
    return {
      email: ''
    }
  },
  methods: {
    subscribe() {
      if (this.email) {
        // Handle newsletter subscription
        console.log('Subscribe:', this.email)
        // You can add API call here
        this.email = ''
      }
    }
  }
}
</script>

<style scoped>
.newsletter-section {
  background-color: #1a1a2e;
  padding: 60px 0;
}

.newsletter-box {
  background: linear-gradient(30deg, #1a1423 0%, #6320ee 100%);
  padding: 50px 60px;
  border-radius: 8px;
  text-align: center;
  box-shadow: 0 8px 32px rgba(124, 58, 237, 0.3);
}

.newsletter-title {
  font-size: 28px;
  font-weight: 700;
  color: white;
  margin-bottom: 8px;
}

.newsletter-subtitle {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.9);
  margin-bottom: 32px;
  line-height: 1.5;
}

.newsletter-form {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  max-width: 380px;
  margin: 0 auto;
}

.form-group {
  width: 100%;
}

.form-label {
  display: block;
  text-align: left;
  font-size: 13px;
  font-weight: 500;
  color: white;
  margin-bottom: 8px;
}

.email-input {
  width: 100%;
  padding: 10px 14px;
  font-size: 14px;
  border: none;
  border-radius: 4px;
  background-color: white;
  color: #1a1a2e;
  outline: none;
  transition: box-shadow 0.3s ease;
}

.email-input:focus {
  box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.3);
}

.email-input::placeholder {
  color: #999;
}

.subscribe-btn {
  padding: 10px 28px;
  font-size: 14px;
  font-weight: 600;
  color: white;
  background-color: #E8552E;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s ease;
  letter-spacing: 0.3px;
  align-self: flex-start;
}

.subscribe-btn:hover {
  background-color: #E85D2C;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(255, 107, 53, 0.4);
}

.subscribe-btn:active {
  transform: translateY(0);
}

/* Responsive Design */
@media (max-width: 960px) {
  .newsletter-section {
    padding: 50px 0;
  }

  .newsletter-box {
    padding: 45px 35px;
  }

  .newsletter-title {
    font-size: 26px;
  }

  .newsletter-subtitle {
    font-size: 14px;
  }
}

@media (max-width: 600px) {
  .newsletter-section {
    padding: 40px 15px;
  }

  .newsletter-box {
    padding: 35px 20px;
    border-radius: 8px;
  }

  .newsletter-title {
    font-size: 22px;
    line-height: 1.3;
  }

  .newsletter-subtitle {
    font-size: 13px;
    line-height: 1.6;
    margin-bottom: 24px;
  }

  .form-group {
    max-width: 100%;
  }
  
  .email-input {
    padding: 12px;
    font-size: 14px;
  }

  .subscribe-btn {
    width: 100%;
    max-width: 100%;
    padding: 12px 28px;
  }
}

@media (max-width: 400px) {
  .newsletter-title {
    font-size: 20px;
  }
  
  .newsletter-subtitle {
    font-size: 12px;
  }
}
</style>
